import type { EntitlementState } from '../domain/entitlement';

export const COMMERCE_COPY: Record<EntitlementState, { title: string; detail: string; action: string }> = {
  unavailable: {
    title: '구매는 아직 열리지 않았어요',
    detail: '결제 제공자와 상품을 확인하기 전에는 결제를 시작하지 않습니다. 무료 여행은 그대로 완성할 수 있어요.',
    action: '무료로 계속 준비하기',
  },
  ready: {
    title: '평생권을 확인했어요',
    detail: '표시 가격과 환불 조건을 확인한 뒤 한 번만 결제합니다.',
    action: '평생권 구매하기',
  },
  pending: {
    title: '결제 확인을 기다리고 있어요',
    detail: '앱을 닫아도 다시 확인합니다. 확인 전에는 프리미엄 권리를 미리 열지 않아요.',
    action: '결제 상태 다시 확인',
  },
  paid_ungranted: {
    title: '결제는 확인됐고 권리를 연결하고 있어요',
    detail: '중복 결제하지 마세요. 잠시 뒤 자동 대사하고, 계속되면 주문 참조값으로 문의할 수 있어요.',
    action: '권리 다시 확인',
  },
  granted: {
    title: '평생권이 연결됐어요',
    detail: '이 기기의 기존 여행은 그대로 두고 확장 한도만 열었습니다.',
    action: '여행 준비 계속하기',
  },
  restored: {
    title: '평생권을 복원했어요',
    detail: '확인된 구매 이력으로 확장 권리를 다시 연결했습니다.',
    action: '여행 준비 계속하기',
  },
  refunded: {
    title: '환불이 확인됐어요',
    detail: '새 프리미엄 생성은 무료 한도로 돌아갑니다. 기기에 저장된 여행과 내보내기 자료는 지우지 않아요.',
    action: '무료로 계속 준비하기',
  },
  chargeback: {
    title: '결제 취소가 확인됐어요',
    detail: '확장 권리는 중단했지만 기기에 저장된 여행은 지우지 않았어요. 이의가 있으면 주문 참조값으로 문의해 주세요.',
    action: '문의하기',
  },
  revoked: {
    title: '구매 권리를 다시 확인해야 해요',
    detail: '확인 전까지는 무료 한도로 안전하게 동작합니다. 저장한 여행은 그대로예요.',
    action: '구매 권리 확인',
  },
};
